import React from 'react';

import styles from './CaseMainTitle.module.scss';

export function CaseMainTitle({ children }) {
  return <div className={styles.case_main_title}>{children}</div>;
}
